<template>
    <d-container fluid class="main-content-container px-4">
        <d-row no-gutters class="page-header py-4">
            <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
                <h3 class="page-title">Profile</h3>
            </d-col>
        </d-row>
        <d-row>
            <d-col lg="4">
                <user-details />
            </d-col>
            <d-col lg="8">
                <user-account-details />
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
import UserDetails from '@/components/user-profile/UserDetails.vue';
import UserAccountDetails from '@/components/user-profile/UserAccountDetails.vue';

export default {
    name: 'user-profile',
    components: {
        UserDetails,
        UserAccountDetails,
    },
};
</script>
